module.exports = __webpack_public_path__ + "static/media/robot_apps.386d15d6.svg";